export const capitalizeString = (str: string) => str.substring(0, 1).toUpperCase() + str.substring(1)
